import { DateTime } from "luxon";
import { CloseButton, Modal } from "react-bootstrap";
import SUMMER_CARNIVAL_BANNER from "../../assets/images/2025JunePromo.png";

const USER_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const TIME_START = DateTime.fromISO('2025-06-26T14:00:00Z');
export const TIME_END = DateTime.fromISO('2025-07-01T14:00:00Z');

export function AnnouncementModal({ styleCss, ...props }) {
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      contentClassName={styleCss + `fixthislater light-color`}
      centered
    >
      <Modal.Body className={"p-0"}>
        <div className="card card-user shadow-lg">
          <div className="pt-4 px-4">
            <div className="d-flex justify-content-between">
              <h5 className="mb-0">WHAT'S NEW</h5>
              <CloseButton onClick={props.onHide} />
            </div>
            <small>June 26th - July 1st</small>
          </div>
          <div className={"card-body px-4" + (styleCss === 'dark' ? ' pb-0' : '')} style={{ maxHeight: '500px', overflowY: 'scroll' }}>
            <div className="d-flex">
              <img src={SUMMER_CARNIVAL_BANNER} alt="Summer Carnival" className="img-fluid mb-1 rounded mx-auto w-100"></img>
            </div>
            {/* <div className="rounded-3" style={{ width: '100%', overflow: 'hidden', maxHeight: '240px', position: 'relative' }}>
              <video className="rounded-3" style={{ width: '100%', height: '100%', transform: 'translate(0, -10%)' }} autoPlay playsInline>
                <source src="https://i.imgur.com/yANeMmt.mp4" type="video/mp4" />
              </video>
            </div> */}
            {/* <div className="d-flex justify-content-between mt-3 text-primary">
              <h6>SHOP&nbsp;IS&nbsp;LIVE&nbsp;</h6>
              <hr className="w-100 mt-2" />
            </div>

            <ul>
              <li>Spend your points @ <a href="https://shop.degencoinflip.com" target="_blank" rel="noopener noreferrer"><b>shop.degencoinflip.com</b></a> and claim RFFs and other rewards.</li>
            </ul> */}
            <div className="d-flex justify-content-between mt-3 text-warning">
              <h6>DEGEN&nbsp;COIN&nbsp;SHOP:&nbsp;SUMMER&nbsp;CARNIVAL&nbsp;SPECTACULAR</h6>
              <hr className="w-100 mt-2" />
            </div>

            <ul>
              <li>Step right up! The Summer Carnival Spectacular has arrived with <b className="text-gold-300">over $125,000 in prizes</b>, dazzling games, legendary rewards, and carnival magic around every corner.</li>
              <br />
              <li>The midway is buzzing and our degen coin shop is now OPEN for business! Earn points playing any DCF game, then cash them in for rare treasures, chests filled with sol, carnival treats, and exclusive raffles (<b className="text-gold-300">Rolex</b> & <b className="text-gold-300">$10,000</b>)</li>
              <br />
              <li className="text-muted">Starting {TIME_START.setZone(USER_TIMEZONE).toFormat('MMMM dd, yyyy \'at\' h:mm a')} <span className="text-xs">({TIME_START.setZone(USER_TIMEZONE).toFormat('z')})</span></li>
              <li className="text-muted">Til {TIME_END.setZone(USER_TIMEZONE).toFormat('MMMM dd, yyyy \'at\' h:mm a')} <span className="text-xs">({TIME_END.setZone(USER_TIMEZONE).toFormat('z')})</span></li>
              <br />
              <li>Spend your points @ <a href="https://shop.degencoinflip.com" rel="noopener noreferrer"><b>the shop</b></a>.</li>
            </ul>

            <div className="d-flex justify-content-between mt-3 text-primary">
              <h6>DCF&nbsp;ECOSYSTEM&nbsp;UPDATES</h6>
              <hr className="w-100 mt-2" />
            </div>

            <ul>
              <li>- Big Degen rewards (<b className="text-gold-300">$35,000</b>) sent June</li>
              <li>- Crash now playable with just 0.001 SOL</li>
              <li>- Better handling for Solana network issues</li>
              <li>- No more confusing point rates, 50 points per sol played all games</li>
            </ul>

            <div className="d-flex justify-content-between mt-3 text-info">
              <h6>ONGOING&nbsp;EVENTS</h6>
              <hr className="w-100 mt-2" />
            </div>

            <ul>
              <li>- KYC Bonus: Earn up to <b className="text-gold-300">$400</b> for 45 seconds of your time</li>
              <li>- Guaranteed <b className="text-gold-300">$25,000</b> airdrop split to our biggest degens in July</li>
              <br />
              <li><a href="https://discord.gg/degencoinflip" className="text-primary" rel="noreferrer" target="_blank">Join our discord for more info!</a></li>
            </ul>

            <div className="d-flex justify-content-between mt-3 text-success">
              <h6>COMMUNITY&nbsp;STREAMS</h6>
              <hr className="w-100 mt-2" />
            </div>

            <ul>
              <li>Play with friends on voice in <a href="https://discord.gg/degencoinflip" className="text-primary" rel="noreferrer" target="_blank">discord</a> and follow us on <a href="https://twitter.com/degencoinflip" className="text-primary" rel="noreferrer" target="_blank">Twitter</a>.</li>
            </ul>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
